<template>
    <div>
        <v-container fluid pa-5 style="max-width: 600px;">
			<h3 class="text-center mb-5 blue--text">SELECT CATEGORY</h3>
            <v-tabs centered>
                <v-tab @click="tabs.material = false, tabs.webBooks = true">Web books</v-tab>
                <v-tab @click="tabs.webBooks = false, tabs.material = true">Youtube</v-tab>

				<v-tab-item v-show="tabs.webBooks">
					<v-container>
						<v-expansion-panels focusable class="mt-5">
							<v-expansion-panel v-for="(template, index) in webBookTemplates" :key="index">
								<v-expansion-panel-header dense class="font-weight-bold">
									<span class="text-center"> {{ template.title }}</span>
								</v-expansion-panel-header>

								<v-expansion-panel-content>
									<v-container>
										<ul class="directory-list">
											<li v-for="(series, seriesIndex) in template.series_list" :key="seriesIndex"
												class="folder"
											>
												<span @click="showDetails(series.id)">  {{ series.title }}</span>

												<ul v-if="selectedSeries == series.id">
													<li v-for="(textbook, textbookIndex) in series.textbook_list" :key="textbookIndex">
														<span @click="goToPreview(textbook.id, textbook.title)">{{ textbook.title }}</span>
													</li>
												</ul>
											</li>
										</ul>
									</v-container>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</v-container>
				</v-tab-item>

				<v-tab-item v-show="tabs.material">
					<v-container>
                        <v-expansion-panels focusable class="mt-5">
                            <v-expansion-panel v-for="(course, index) in materialCourses" :key="index">
                                <v-expansion-panel-header dense class="font-weight-bold ">
                                    <span class="text-center">  {{ course.title }}</span>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-container>
                                        <ul class="directory-list">
                                            <li v-for="unit in course.list_units" :key="unit.id" class="folder mb-2">
                                                <span @click="redirectToMaterialPreview(unit.id)"> {{ unit.title }}</span>
                                            </li>
                                        </ul>
                                    </v-container>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
					</v-container>
				</v-tab-item>
            </v-tabs>
        </v-container>
    </div>
</template>

<script>
import axios from "axios"
import { mapState } from "vuex"
import { bus } from "@/main"
export default {
    data () {
        return {
            tabs: {
                webBooks: true,
                material: false
            },
            selectedSeries: null,
            materialCourses: null,
            webBookTemplates: null
        }
    },
    computed: {
        ...mapState("user", ["user"])
    },
    watch: {
        user (val) {
            if (val !== null) {
                this.getWebBookList().then(() => {
                    setTimeout(() => {
                        bus.$emit("toggleModal", false, "success", "")
                    }, 1000)
                }).catch(err => {
                    throw Error(err)
                })
            }
        }
    },
    mounted () {
        if (this.user != null) {
            this.getWebBookList().then(() => {
                setTimeout(() => {
                    bus.$emit("toggleModal", false, "success", "")
                }, 1000)
            }).catch(err => {
                throw Error(err)
            })
        }
    },
    methods: {
        async getWebBookList () {
            try {
                const response1 = await axios.get("/megatalking/v1/web-book-list")
                if (response1) {
                    const response2 = await axios.get("/megatalking/v1/materials-for-list")
                    if (response2) {
                        this.webBookTemplates = response1.data
                        this.materialCourses = response2.data
                    }
                }
                else {
                    throw Error("Unable to get book list.")
                }
            }
            catch (err) {
                throw Error(err)
            }
        },

        showDetails (id) {
            this.selectedSeries = id
        },

        goToPreview (id, title) {
            bus.$emit("toggleModal", true, "loading", "loading")
            var queries = { bookid: id, title }
            if (this.$route.query.enc) {
                const enc = { enc: this.$route.query.enc }
                queries = { ...queries, ...enc }
            }
            if (this.$route.query.u) {
                const u = { u: this.$route.query.u }
                queries = { ...queries, ...u }
            }
            setTimeout(() => {
                this.$router.push({ name: "Preview", query: queries })
            }, 1000)
        },

        redirectToMaterialPreview (id) {
            // const url = "https://ueducms.org/content-management/dist/#/reader/material/" + id
            var user = JSON.parse(localStorage.getItem(process.env.VUE_APP_STORAGE_NAME))
            var token = `${user.id}|${user.account_type}|${user.client}`
            const url = `${process.env.VUE_APP_CMS_URL}reader/material/${id}?token=${btoa(token)}`
            window.open(url)
        }
    }
}
</script>

<style scoped>

ul.units li {
    margin: 0 -30px;
    padding: 5px 20px;
    list-style: none !important;
    width: 100%;
    transition: all 0.5s ease-in-out;
    cursor: pointer;
    border-bottom: 1px solid rgb(223, 220, 220);
}

ul.units li:hover {
    background-color: #c6dee6;
}

.directory-list ul {
  margin-left: 10px;
  padding-left: 20px;
  border-left: 1px dashed #ddd;
}

.directory-list li {
  list-style: none;
  color: #888;
  font-size: 15px;
  /* font-style: italic; */
  font-weight: normal;
}

.directory-list a {
  border-bottom: 1px solid transparent;
  color: #0099cc;
  text-decoration: none;
  transition: all 0.5s ease-in-out;
}

.directory-list a:hover {

  font-weight: bold;
}

.directory-list .folder,
.directory-list .folder > a {
  color: #777;
  font-weight: bold;
  cursor: pointer;
}

.directory-list li .youtube-info {
    color: #ff8000 !important;
}

.directory-list li span.label {
    color: #535353 !important;
    font-size: 14px;
    font-weight: 600;
}

/* The icons
-------------------------------------------------------------- */

.directory-list li:before {
  margin-right: 10px;
  content: "";
  height: 20px;
  vertical-align: middle;
  width: 20px;
  background-repeat: no-repeat;
  display: inline-block;
  /* file icon by default */
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><path fill='lightgrey' d='M85.714,42.857V87.5c0,1.487-0.521,2.752-1.562,3.794c-1.042,1.041-2.308,1.562-3.795,1.562H19.643 c-1.488,0-2.753-0.521-3.794-1.562c-1.042-1.042-1.562-2.307-1.562-3.794v-75c0-1.487,0.521-2.752,1.562-3.794 c1.041-1.041,2.306-1.562,3.794-1.562H50V37.5c0,1.488,0.521,2.753,1.562,3.795s2.307,1.562,3.795,1.562H85.714z M85.546,35.714 H57.143V7.311c3.05,0.558,5.505,1.767,7.366,3.627l17.41,17.411C83.78,30.209,84.989,32.665,85.546,35.714z' /></svg>");
  background-position: center 2px;
  background-size: 60% auto;
}

.directory-list li.folder:before {
  /* folder icon if folder class is specified */
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><path fill='lightblue' d='M96.429,37.5v39.286c0,3.423-1.228,6.361-3.684,8.817c-2.455,2.455-5.395,3.683-8.816,3.683H16.071 c-3.423,0-6.362-1.228-8.817-3.683c-2.456-2.456-3.683-5.395-3.683-8.817V23.214c0-3.422,1.228-6.362,3.683-8.817 c2.455-2.456,5.394-3.683,8.817-3.683h17.857c3.422,0,6.362,1.228,8.817,3.683c2.455,2.455,3.683,5.395,3.683,8.817V25h37.5 c3.422,0,6.361,1.228,8.816,3.683C95.201,31.138,96.429,34.078,96.429,37.5z' /></svg>");
  background-position: center top;
  background-size: 75% auto;
}

</style>
